import { Helmet } from "react-helmet-async";

export function useOpenGraph({
  title,
  description,
  image,
  url,
  type = "website",
}) {
  return (
    <Helmet>
      {/* Open Graph / Facebook */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      {type && <meta property="og:type" content={type} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}

      {/* Standard meta tags */}
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}
